<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="openPictureRequired()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--input">
            <td style="width: 25%">
              <span>{{ 'plugins.states.status' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <!--<validation-message [validationControl]="editForm.controls.states" [validationName]="'required'" [errorMessage]="'common.required' | translate"></validation-message>-->
                <p class="ir-required th-required" [class.visible]="!isStatusValid()">
                  <span>{{ 'common.required' | translate }}</span>
                </p>
                <input type="hidden" name="states" class="ir-form-set" formControlName="states" />
                <div class="ir-line ir-select th-select" (click)="openStatesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.states.value != -1
                        ? (editForm.controls.states.value | statespipe)
                        : ('plugins.states.select-status' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td style="width: 25%">
              <span>{{ 'plugins.states.impact' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div
                class="ir-item-line clickable indent nobreak"
                *ngFor="let impactValue of impactSelectorValues; let last = last"
                (click)="changeImpact(impactValue.value)"
              >
                <div class="ir-item-cell">
                  <p class="ir-required th-required" [class.visible]="!isImpactValid() && last">
                    <span>Required</span>
                  </p>
                  <div class="ir-item-selector">
                    <i class="material-icons" *ngIf="!impact.getImpactValue(impactValue.value)">check_box_outline_blank</i>
                    <i class="material-icons" *ngIf="impact.getImpactValue(impactValue.value)">check_box</i>
                  </div>
                  <span>{{ impactValue.label }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td style="width: 25%">
              <span>{{ 'plugins.states.actions' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <p class="ir-required th-required" [class.visible]="!isActionValid()">
                  <span>{{ 'common.required' | translate }}</span>
                </p>
                <!--<validation-message [validationControl]="editForm.controls.action" [validationName]="'required'" [errorMessage]="'common.required' | translate"></validation-message>-->
                <input type="hidden" name="action" class="ir-form-set" formControlName="action" />
                <div class="ir-line ir-select th-select" (click)="openActionSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.action.value != -1
                        ? (editForm.controls.action.value | actionspipe)
                        : ('plugins.states.select-action' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isStatusOk" class="th-plugin-line--input">
            <td>
              <span>{{ 'plugins.observation.priority' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div *ngFor="let prio of priorities; let last = last" (click)="changePriority(prio)">
                <div class="ir-item-line clickable indent nobreak">
                  <div class="ir-item-cell">
                    <p class="ir-required th-required" [class.visible]="!isPrioValid() && last">
                      <span>Required</span>
                    </p>
                    <div class="ir-item-selector test">
                      <i class="material-icons" *ngIf="!isPriority(prio)">radio_button_unchecked</i>
                      <i class="material-icons important" *ngIf="isPriority(prio)">radio_button_checked</i>
                    </div>
                    <span>{{ prio.value | stateprioritypipe }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid || !isImpactValid() || !isStatusValid() || !isActionValid() || !isPrioValid()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectStatesMenu($event)" (modalClosed)="onStatesMenuClose()" #statesModal></modal>
<modal (modalOutput)="selectActionMenu($event)" (modalClosed)="onActionMenuClose()" #actionModal></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #pictureRequiredConfirm
  (confirmOutput)="save()"
  [title]="'plugins.states.picture-required-title' | translate"
  [message]="'plugins.states.picture-required-text' | translate"
  [danger]="true"
></confirm>
